import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "surface-section px-6 py-5" }
const _hoisted_2 = { class: "flex align-items-start flex-column lg:flex-row lg:justify-content-between" }
const _hoisted_3 = { class: "flex align-items-start flex-column md:flex-row" }
const _hoisted_4 = {
  key: 0,
  class: "text-900 font-medium text-3xl"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-star text-2xl ml-4 text-yellow-500" }, null, -1)
const _hoisted_6 = { class: "flex align-items-center flex-wrap text-sm" }
const _hoisted_7 = { class: "mr-5 mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "font-medium text-500"
}
const _hoisted_9 = {
  key: 1,
  class: "text-700 mt-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mr-5 mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-500" }, "ACCOUNT"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-700 mt-2" }, "Premium")
], -1)
const _hoisted_11 = { class: "mt-3 lg:mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"78vh"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Avatar, {
                image: "https://www.gravatar.com/avatar/05dfd4b41340d09cae045235eb0893c3?d=mp",
                class: "flex align-items-center justify-content-center mr-2",
                size: "xlarge"
              }),
              _createElementVNode("div", null, [
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.currentUser?.username), 1))
                  : (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      modelValue: _ctx.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                      placeholder: "Username"
                    }, null, 8, ["modelValue"])),
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (!_ctx.editMode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "EMAIL"))
                      : _createCommentVNode("", true),
                    (!_ctx.editMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.currentUser?.email), 1))
                      : (_openBlock(), _createBlock(_component_InputText, {
                          key: 2,
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                          placeholder: "Email"
                        }, null, 8, ["modelValue"]))
                  ]),
                  _hoisted_10
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (!_ctx.editMode)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _ctx.toggleEditMode,
                    icon: "pi pi-pencil",
                    class: "p-button-rounded mr-2"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.editMode)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _ctx.toggleEditMode,
                label: "Cancel",
                severity: "secondary",
                outlined: "",
                class: "mt-5 mr-3"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.editMode)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _ctx.updateUser,
                label: "Update Profile",
                class: "mt-5"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}